<template>
  <div class="w-100 carousel-main-height-wrapper">
    <div class="container-fluid px-2 px-md-3 position-relative section-padding">
      <div class="row align-items-center mb-2">
        <div class="col-12 text-left px-0">
          <div class="w-100">
            <span class="rails-header-title">Episod</span>
          </div>
        </div>
      </div>
      <div
        class="row mr-0 mr-lg-up latest-player-episodes-rails-content"
        id="playerEpisodesV2"
      >
        <div class="owl-carousel owl-theme" id="playerEpisodesDesktopRails">
          <div
            class="item"
            v-for="item_vod in data"
            :key="item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <episodeCard
              :image="item_vod.img_link"
              :title="item_vod.longTitle"
              :link="item_vod.redirect_link"
              :description="item_vod.data.description"
              :locked="lockedlist"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import episodeCard from "../../../cards/v2/episodeCard.vue";
import ChevronRight from "../../../../assets/rtmklik/svg/theme_chevron_right.svg";
import ChevronLeft from "../../../../assets/rtmklik/svg/theme_chevron_left.svg";
export default {
  props: ["data", "lockedlist"],
  data: function() {
    return {
      vod: [],
      headerTitle: "Continue Watching",
      id: 3553,
      hover: false,
      userId: localStorage.getItem("user_id"),
    };
  },
  components: { episodeCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 6,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveRefreshRate: 10,
        responsiveClass: true,
        navText: [`<img src=${ChevronLeft} />`, `<img src=${ChevronRight} />`],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 10,
            stagePadding: 0,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            nav: false,
            margin: 14,
          },
          992: {
            items: 6,
            stagePadding: 0,
            loop: false,
            nav: true,
            margin: 6,
          },
          1440: {
            items: 7,
            stagePadding: 2,
            loop: false,
            nav: true,
            margin: 8,
          },
        },
      });
    },

    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  mounted() {
    // this.getContinueWatchingList();
    var vm = this;
    Vue.nextTick(
      function() {
        if (vm.data) {
          vm.installOwlCarousel("#playerEpisodesDesktopRails");
        }
      }.bind(vm)
    );
  },
};
</script>

<style>
.latest-player-episodes-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#playerEpisodesV2 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #playerEpisodesV2 .owl-theme:hover {
    z-index: 111;
  }

  #playerEpisodesV2 .owl-theme {
    height: auto;
  }
  #playerEpisodesV2 .owl-item {
    z-index: 1;
  }
  #playerEpisodesV2 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    transform: scale(1.2);
    z-index: 2000;
  }

  #playerEpisodesV2 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #playerEpisodesV2 .owl-theme .owl-nav {
    position: absolute;
    top: -48px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
  }

  #playerEpisodesV2 .owl-prev img {
    width: 22px;
    height: 23px;
  }

  #playerEpisodesV2 .owl-next img {
    width: 22px;
    height: 23px;
  }
}
</style>
